import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import Vue from 'vue';
import Dialog from './dialog.js';

var DialogConstruct = Vue.extend(Dialog);

function show(props) {
  var _props$appendTo = props.appendTo,
      appendTo = _props$appendTo === void 0 ? document.body : _props$appendTo;
  var dialogInstance;

  var close = function close(callback) {
    if (!dialogInstance) return; // 销毁动画

    dialogInstance.visible = false;
    setTimeout(function () {
      var _ref;

      // 删除dom
      (_ref = props.appendTo || document.body) === null || _ref === void 0 ? void 0 : _ref.removeChild(dialogInstance.$el); // 销毁实例

      dialogInstance.$destroy();
      dialogInstance = null; // 回调

      callback === null || callback === void 0 ? void 0 : callback();
    }, 510);
  };

  var init = function init() {
    // 创建实例
    dialogInstance = new DialogConstruct({
      el: document.createElement('div'),
      propsData: _objectSpread2(_objectSpread2({}, props), {}, {
        visible: true
      })
    }); // 添加dom到body里面

    appendTo.appendChild(dialogInstance.$el); // ok

    dialogInstance.$on('ok', function () {
      close(props.onOk);
    }); // cancel

    dialogInstance.$on('cancel', function () {
      close(props.onCancel);
    }); // close

    dialogInstance.$on('close', function () {
      close(props.onClose);
    });
  };

  var update = function update(props) {
    if (!dialogInstance) return;
    Object.keys(props).forEach(function (key) {
      dialogInstance[key] = props[key];
    });
  };

  init();
  return {
    update: update,
    close: close
  };
}

var alert = function alert(props) {
  var defaultProps = {
    showCancel: false
  };
  return show(_objectSpread2(_objectSpread2({}, defaultProps), props));
};

var confirm = show;
var Dialoger = {
  show: show,
  alert: alert,
  confirm: confirm
};

export { Dialoger as default };
//# sourceMappingURL=dialoger.js.map
